import { ArticleParagraph2, IconPlaceholderImages24 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './CarouselNoMedia.css';

export const CarouselNoMedia: React.FC = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <IconPlaceholderImages24 color="black_40" width={40} height={40} />
        <ArticleParagraph2 color="black_40">Фотографии отсутствуют</ArticleParagraph2>
      </div>
    </div>
  );
};
